import { ScreenSizes } from '../classes/screen-sizes.class';

let scrollPosition = undefined;

const DisableScrollkeys = new Set();

/**
 * Disables body scroll
 * @param key When a key is passed, the body scroll can only be enabled again if that key is passed
 */
export const disableBodyScroll = (key?: string, isExtension = false): void => {
  if (scrollPosition !== undefined) return;
  if (key) DisableScrollkeys.add(key);
  const $body = document.querySelector('body');
  scrollPosition = window.pageYOffset;
  $body.style.overflow = 'hidden';
  $body.style.top = `-${scrollPosition}px`;
  if (ScreenSizes.screenSize() === 'mobile' && !isExtension) $body.style.position = 'fixed';
  $body.style.width = '100%';
};

export const enableBodyScroll = (key?: string): void => {
  if (key) DisableScrollkeys.delete(key);
  if (DisableScrollkeys.size) {
    console.debug('Didnt re-enable scroll because some keys are still active', DisableScrollkeys);
    return;
  }
  const $body = document.querySelector('body');
  $body.style.removeProperty('overflow');
  $body.style.removeProperty('position');
  $body.style.removeProperty('top');
  $body.style.removeProperty('width');
  window.scrollTo(0, scrollPosition);
  scrollPosition = undefined;
};
